// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"0b05d086","268":"c9228563","977":"7f5a2930"}[chunkId] + ".chunk.js";
};